export default __webpack_public_path__ + "static/media/logo-signature.efa5055a.png";